export const getConsumerTickets = (consumerId) => {
  return {
    type: 'GET_CONSUMER_TICKETS',
    payload: { consumerId },
  }
}

export const setConsumerTickets = (consumerId, data) => {
  return {
    type: 'SET_CONSUMER_TICKETS',
    payload: { consumerId, data },
  }
}

export const apiError = (consumerId, error) => {
  return {
    type: 'API_ERROR',
    payload: { consumerId, error },
  }
}
